//@flow
import * as Immutable from 'immutable';
import OutletLocationActions from 'common/redux/actions/locationGeocodeEdit';
import { GeocodeVerifiedGeometry as GeocodeValidatedGeometry } from 'common/models/internal/GeocodeVerifiedGeometry';

export const outletLocationGeocodeEditReducer = (
    state: Object = Immutable.fromJS({ records: {} }),
    action: Object
): Object => {
    switch (action.type) {
        case OutletLocationActions.EDIT_OUTLET_LOCATION_LATLNG_START: {
            const { params } = action;
            const { clientId } = params;
            const { body } = action;
            const { edits } = body;
            const editedIds = Immutable.fromJS(
                edits.map(edit => {
                    return edit.locationId;
                })
            );
            return state.setIn(
                ['records', clientId, 'editingEntityIds'],
                editedIds
            );
        }
        case OutletLocationActions.EDIT_OUTLET_LOCATION_LATLNG_SUCCESS: {
            const { body, params } = action;
            const { clientId } = params;
            const { edits } = body;
            const editedIds = Immutable.fromJS(
                edits.map(edit => {
                    return edit.locationId;
                })
            );
            let updatedEditingEntityIds = state.getIn(
                ['records', clientId, 'editingEntityIds'],
                []
            );
            updatedEditingEntityIds = updatedEditingEntityIds.filter(
                id => !editedIds.includes(id)
            );
            return state.setIn(
                ['records', clientId, 'editingEntityIds'],
                updatedEditingEntityIds
            );
        }
        case OutletLocationActions.EDIT_OUTLET_LOCATION_LATLNG_ERROR: {
            const { body, params } = action;
            const { clientId } = params;
            const { edits } = body;
            const editedIds = Immutable.fromJS(
                edits.map(edit => {
                    return edit.locationId;
                })
            );
            let updatedEditingEntityIds = state.getIn(
                ['records', clientId, 'editingEntityIds'],
                []
            );
            updatedEditingEntityIds = updatedEditingEntityIds.filter(
                id => !editedIds.includes(id)
            );
            return state.setIn(
                ['records', clientId, 'editingEntityIds'],
                updatedEditingEntityIds
            );
        }
        case OutletLocationActions.VERIFY_OUTLET_LOCATION_START: {
            const { body, params } = action;
            const { clientId } = params;
            const { edits } = body;
            const editedIds = Immutable.fromJS(
                edits.map(edit => {
                    return edit.locationId;
                })
            );
            return state.setIn(
                ['records', clientId, 'verifyingEntityIds'],
                editedIds
            );
        }
        case OutletLocationActions.VERIFY_OUTLET_LOCATION_SUCCESS: {
            const { body, params } = action;
            const { edits } = body;

            const { clientId } = params;
            const editedIds = Immutable.fromJS(
                edits.map(edit => {
                    return edit.locationId;
                })
            );
            let updatedVerifyingEntityIds = state.getIn(
                ['records', clientId, 'verifyingEntityIds'],
                []
            );
            updatedVerifyingEntityIds = updatedVerifyingEntityIds.filter(
                id => !editedIds.includes(id)
            );
            return state.setIn(
                ['records', clientId, 'verifyingEntityIds'],
                updatedVerifyingEntityIds
            );
        }
        case OutletLocationActions.VERIFY_OUTLET_LOCATION_ERROR: {
            const { body, params } = action;
            const { clientId } = params;
            const { edits } = body;

            const editedIds = Immutable.fromJS(
                edits.map(edit => {
                    return edit.locationId;
                })
            );
            let updatedVerifyingEntityIds = state.getIn(
                ['records', clientId, 'verifyingEntityIds'],
                []
            );
            updatedVerifyingEntityIds = updatedVerifyingEntityIds.filter(
                id => !editedIds.includes(id)
            );
            return state.setIn(
                ['records', clientId, 'verifyingEntityIds'],
                updatedVerifyingEntityIds
            );
        }
        case OutletLocationActions.CLEAR_OUTLET_LOCATION_VALIDATE_GEOCODE_DATA: {
            const { params } = action;
            const { clientId } = params;
            return state
                .deleteIn(['records', clientId, 'validatingEntityIds'])
                .deleteIn(['records', clientId, 'geocodeValidatedGeometries']);
        }
        case OutletLocationActions.VALIDATE_OUTLET_LOCATION_GEOCODE_START: {
            const { body, params } = action;
            const { clientId } = params;
            const { locationIds } = body;
            const editedIds = Immutable.fromJS(locationIds);
            return state.setIn(
                ['records', clientId, 'validatingEntityIds'],
                editedIds
            );
        }
        case OutletLocationActions.VALIDATE_OUTLET_LOCATION_GEOCODE_SUCCESS: {
            const { body, params, response } = action;
            const { clientId } = params;
            const { locationIds } = body;
            const { responses } = response;
            let updatedGeocodeValidatedGeometries = Immutable.List(
                responses.map(geocodeValidatedGeometry => {
                    return GeocodeValidatedGeometry.fromJS(
                        geocodeValidatedGeometry
                    );
                })
            ).reduce((result, item) => {
                return result.set(item.locationId, item);
            }, Immutable.Map());
            const geocodeValidatedGeometries = state.getIn(
                ['records', clientId, 'geocodeValidatedGeometries'],
                Immutable.Map()
            );

            updatedGeocodeValidatedGeometries = geocodeValidatedGeometries.merge(
                updatedGeocodeValidatedGeometries
            );

            const validatedIds = Immutable.fromJS(locationIds);
            let updatedValidatingEntityIds = state.getIn(
                ['records', clientId, 'validatingEntityIds'],
                []
            );
            updatedValidatingEntityIds = updatedValidatingEntityIds.filter(
                id => !validatedIds.includes(id)
            );
            return state
                .setIn(
                    ['records', clientId, 'validatingEntityIds'],
                    updatedValidatingEntityIds
                )
                .setIn(
                    ['records', clientId, 'geocodeValidatedGeometries'],
                    updatedGeocodeValidatedGeometries
                );
        }
        case OutletLocationActions.VALIDATE_OUTLET_LOCATION_GEOCODE_ERROR: {
            const { body, params } = action;
            const { clientId } = params;
            const { locationIds } = body;

            const editedIds = Immutable.fromJS(locationIds);
            let updatedValidatingEntityIds = state.getIn(
                ['records', clientId, 'validatingEntityIds'],
                []
            );
            updatedValidatingEntityIds = updatedValidatingEntityIds.filter(
                id => !editedIds.includes(id)
            );
            return state.setIn(
                ['records', clientId, 'validatingEntityIds'],
                updatedValidatingEntityIds
            );
        }
        default:
            return state;
    }
};

export default outletLocationGeocodeEditReducer;
